import Tooltip from 'primevue/tooltip';

export default defineNuxtPlugin({
    name: 'primevue',
    dependsOn: [],
    async setup(nuxtApp)
    {
        nuxtApp.vueApp.directive('tooltip', Tooltip);
    }
});
